import { Injectable } from '@angular/core';

/**
 * Builds crawler-readable share URLs. The API endpoint serves the Open Graph
 * metadata (including the asset-specific image) and then redirects visitors
 * to the normal Angular route. Keeping this URL stable means a copied link
 * works in WhatsApp and other clients that do not execute Angular JavaScript.
 */
@Injectable({ providedIn: 'root' })
export class SharePreviewService {
  private readonly apiOrigin = 'https://supercluster-api.laniakea.tv/api';

  feex(productId: string | number, slug?: string): string {
    const id = encodeURIComponent(String(productId ?? '').trim());
    const normalizedSlug = String(slug ?? '').trim();
    const query = normalizedSlug ? `?slug=${encodeURIComponent(normalizedSlug)}` : '';
    return `${this.apiOrigin}/share-preview/feex/${id}${query}`;
  }

  publication(publicationId: string | number): string {
    return `${this.apiOrigin}/share-preview/publication/${encodeURIComponent(String(publicationId ?? '').trim())}`;
  }

  comment(commentId: string | number): string {
    return `${this.apiOrigin}/share-preview/comment/${encodeURIComponent(String(commentId ?? '').trim())}`;
  }
}
